import Icon from 'antd/lib/icon'
import React from 'react'
import styled from 'styled-components'

interface StyledProps {
  color?: string
}

export const Container = styled.div`
  width: 97%;
  height: 17px;
  background-color: ${({ color }: StyledProps) => color || '#02aff2'};
  margin-top: 20px;
  border-radius: 10px;
  position: relative;
  animation: fade-in-bottom-folder 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-bottom-folder {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const FolderTab = styled.div`
    width: 10%;
    height: 25px;
    background-color: #02aff2;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    position: absolute;
    bottom: 8px;
    display: flex;
    justify-content: center;
`

export const FolderName = styled.p`
  color: white;
  font-weight: 600;
  position: absolute;
  z-index: 10;
  top: -6px;
  margin-left: 16px;
`

const SVG = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  viewBox: '0 0 145 25"',
})`
  width: 145px;
  height: 25px;
  position: absolute;
  top: -13px;
`

export const Path = styled.path``

interface SVGFolderTabProps {
  color?: string
}

export const SVGFolderTab = ({ color }: SVGFolderTabProps) => (
  <SVG>
    <Path 
      d="M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 
      10V15C32 20.5228 27.5228 25 22 25H0V10Z" 
      fill={color || '#02aff2'}
    />
    <Path 
      d="M121.552 0H9V25H145L121.552 0Z" 
      fill={color || '#02aff2'}
    />
  </SVG>
)

export const CloseTab = styled.div`
  position: absolute;
  left: 140px;
  bottom: 17px;
  font-size: 12px;
  background: #fcdddd;
  border-top-left-radius: 7px;
  border-top-right-radius: 8px;
  padding: 2px 10px;
  border-bottom: none;
  padding-right: 22px;
  color: #813636;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CloseIcon = styled(Icon)`
  background: #df7a7a;
  color: white;
  border-radius: 25px;
  padding: 2px;
  font-size: 10px;
  position: absolute;
  right: 3px;
  bottom: 2px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/FoldersLayout/styledComponents.tsx